import React from 'react';
import { View, Dimensions, Text, Image, ScrollView, ActivityIndicator, ImageBackground } from 'react-native';
import { CheckBox, Button, Input, Avatar } from 'react-native-elements';
import moment from 'moment';
import Modal from 'modal-enhanced-react-native-web';
import Lib from '../Lib';

const { remainingText, showToast } = Lib;
const { IMG_DATA, USDT, TOKEN, TOKEN_NAME } = require('../Data');
const { burn, getOwnedNFT, getNextSessionTime, openExplorerNft, retrieveReward, publishWalletData, openExplorerTx, getNFTDetail } = require('../BlockLib');

class PanelManage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: 'busy',
      currentIndex: 0,
      nfts: [],
      nextSessionTime: 0,
      ticker: 0
    };
  }

  async componentDidMount() {
    const nfts = await getOwnedNFT();
    const nextSessionTime = await getNextSessionTime();
    this.setState({ show: 'list', nfts, nextSessionTime });

    this.interval = setInterval(() => {
      const newTicker = this.state.ticker + 1;
      this.setState({ ticker: newTicker });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async refresh() {

  }

  async handleRetrieveReward() {
    const dataList = this.state.nfts;
    const currentIndex = this.state.currentIndex;
    const nftId = dataList[currentIndex].nftId;

    try {
      this.setState({ modalVisible: true, txHash: false });
      const txHash = await retrieveReward(nftId);
      await publishWalletData();
      const nfts = await getOwnedNFT();
      this.setState({ txHash, nfts });
    } catch (err) {
      if (err && err.message) showToast(err.message);
    }
  }

  async handleBurn() {
    const dataList = this.state.nfts;
    const currentIndex = this.state.currentIndex;
    const nftId = dataList[currentIndex].nftId;
    const earning = Number(dataList[currentIndex].earning);

    if (earning > 0) return showToast('retrieve earning first'.toUpperCase());

    try {
      this.setState({ modalVisible: true, txHash: false });
      const txHash = await burn(nftId);
      await publishWalletData();
      const nfts = await getOwnedNFT();
      this.setState({ txHash, nfts, currentIndex: 0 });
    } catch (err) {
      if (err && err.message) showToast(err.message);
    }
  }

  renderBusy() {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <Text> </Text>
        <Text style={{ textAlign: 'center' }}>QUERYING OWNED NFTS</Text>
        <Text> </Text>
        <ActivityIndicator />
      </View>
    );
  }

  renderModal() {
    let indicator = <ActivityIndicator />;
    let msg = 'PROCESS TX';
    if (this.state.txHash) {
      msg = 'PROCESS TX DONE';
      const txHash = this.state.txHash;
      indicator = <Button type="outline" title='OPEN ON EXPLORER' onPress={() => openExplorerTx(txHash)} />
    }

    return (
      <Modal
        isVisible={this.state.modalVisible}
        onBackdropPress={() => this.setState({ modalVisible: false })}
      >
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ backgroundColor: 'white', padding: 20 }}>
            <Text> </Text>
            <Text style={{ textAlign: 'center' }}>{msg}</Text>
            <Text> </Text>
            <View>
              {indicator}
              <Text> </Text>
              <Button type="outline" title='CLOSE' onPress={() => this.setState({ modalVisible: false })} />
            </View>
            <Text> </Text>
          </View>
        </View>
      </Modal>
    );
  }

  render() {
    if (this.state.show === 'busy') return this.renderBusy();
    const dataList = this.state.nfts;

    const totalIndex = dataList.length;
    const currentIndex = this.state.currentIndex;
    const nextSessionTime = this.state.nextSessionTime;

    let content = (
      <View>
        <Text style={{ textAlign: 'center' }}>NOT OWNED ANY WARRIORS</Text>
        <Text> </Text>
      </View>
    );
    let title = 'WARRIORS OWNED (0/0)';

    let enablePrev = false;
    let enableNext = false;
    let enableExplore = false;
    let enableEarn = false;
    let enableBurn = false;

    let earningMsg = <Text> </Text>;
    let burningMsg = <Text> </Text>;
    let btnBurnText = 'BURN';

    if (dataList.length > 0) {
      const data = dataList[currentIndex];
      const nftId = data.nftId;
      const power = data.power;
      const earning = Number(data.earning);
      const noPenaltyTime = Number(data.noPenaltyTime);
      const collateral = data.collateral;
      const age = data.age;
      const totalEarning = data.totalEarning;
      const totalEarningUsd = data.totalEarningUsd;
      const pctg = data.pctg;
      const pctgDaily = data.pctgDaily;
      const pctgYearly = data.pctgYearly;


      let name = data.name;
      let url = data.image;

      // const imgData = IMG_DATA;
      // for (let i = 0; i < imgData.length; i++) {
      //   const id = imgData[i];
      //   if (id.power === power) {
      //     name = id.name;
      //     url = id.img;
      //   }
      // }

      enablePrev = (currentIndex > 0);
      enableNext = (currentIndex < totalIndex - 1);
      enableExplore = true;
      enableEarn = (earning > 0);
      enableBurn = true;

      let remainingSecsEarning = 0;
      let remainingSecsPenalty = 0;

      const now = moment().unix();
      if (now < noPenaltyTime) {
        remainingSecsPenalty = noPenaltyTime - now;
      }
      if (now < nextSessionTime) {
        remainingSecsEarning = nextSessionTime - now;
      }

      earningMsg = (
        <View>
          <Text> </Text>
          <Text style={{ textAlign: 'center' }}>EARNING WILL BE AVAILABLE AFTER</Text>
          <Text style={{ textAlign: 'center' }}>{moment.unix(nextSessionTime).format()}</Text>
          <Text> </Text>
        </View>
      );

      if (earning > 0) {
        earningMsg = (
          <View>
            <Text> </Text>
            <Text style={{ textAlign: 'center' }}>EARNING AVAILABLE</Text>
            <Text style={{ textAlign: 'center' }}>{earning} {TOKEN}</Text>
            <Text> </Text>
          </View>
        );
      } else if (remainingSecsEarning > 0) {
        const txt = remainingText(remainingSecsEarning);
        earningMsg = (
          <View>
            <Text> </Text>
            <Text style={{ textAlign: 'center' }}>EARNING WILL BE AVAILABLE AFTER</Text>
            <Text style={{ textAlign: 'center' }}>{txt.toUpperCase()}</Text>
            <Text> </Text>
          </View>
        );
      }

      if (remainingSecsPenalty > 0) {
        const txt = remainingText(remainingSecsPenalty);
        burningMsg = (
          <View>
            <Text> </Text>
            <Text style={{ textAlign: 'center' }}>5% BURN PENALTY APPLIED FOR NEXT</Text>
            <Text style={{ textAlign: 'center' }}>{txt.toUpperCase()}</Text>
            <Text> </Text>
          </View>);
      }

      btnBurnText = 'BURN TO RECEIVE ' + collateral + ' ' + USDT;

      title = 'WARRIORS OWNED (' + (currentIndex + 1) + '/' + totalIndex + ')';

      content = (
        <View style={{}}>
          <Image source={{
            uri: url,
          }} resizeMode="contain" style={{ padding: 10, height: 200 }} />
          <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          </View>
          <Text style={{ textAlign: 'center' }}> </Text>
          <Text style={{ textAlign: 'center' }}>{name.toUpperCase()} (#{nftId})</Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 30 }}>
            <Text>POWER</Text>
            <Text>{power}</Text>
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 30 }}>
            <Text>AGE</Text>
            <Text>{age} DAYS</Text>
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 30 }}>
            <Text>TOTAL EARNING {TOKEN}</Text>
            <Text>{totalEarning} ({totalEarningUsd} {USDT})</Text>
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 30 }}>
            <Text>PROFIT</Text>
            <Text>{pctg} %</Text>
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 30 }}>
            <Text>AVGERAGE DAILY PROFIT</Text>
            <Text>{pctgDaily} %</Text>
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 30 }}>
            <Text>PROJECTED ANNUAL PROFIT</Text>
            <Text>{pctgYearly} %</Text>
          </View>
          {earningMsg}
        </View>
      );
    }

    return (
      <View style={{ padding: 10, backgroundColor: '#eee' }}>
        {this.renderModal()}
        <Text style={{ textAlign: 'center' }}>{title}</Text>
        <Text style={{ textAlign: 'center' }}> </Text>
        {content}
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}><Button disabled={!enablePrev} title="PREV" onPress={() => this.setState({ currentIndex: currentIndex - 1 })} /></View>
          <View style={{ width: 10 }} />
          <View style={{ flex: 1 }}><Button disabled={!enableNext} title="NEXT" onPress={() => this.setState({ currentIndex: currentIndex + 1 })} /></View>
        </View>
        <Text> </Text>
        <View style={{}}><Button disabled={!enableEarn} title="RETRIEVE EARNING" onPress={() => this.handleRetrieveReward()} /></View>
        {burningMsg}
        <View style={{}}><Button disabled={!enableBurn} type="outline" title={btnBurnText} onPress={() => this.handleBurn()} /></View>
        <Text> </Text>
        <View style={{}}><Button disabled={!enableExplore} type="outline" title="EXPLORE" onPress={() => openExplorerNft()} /></View>
        <Text> </Text>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}><Button type="outline" title="BACK" onPress={() => this.props.handleHome()} /></View>
        </View>
      </View>
    );
  }

}

export default PanelManage;
